import React, {useState, useEffect} from 'react'
import {InputNumber, Modal, Button, Spin, List, message} from 'antd'
import styles from '../layout.module.less'
import history from "../../../libs/history";
// import {number} from "../../../libs";

import {observer} from 'mobx-react';
import store from '../store'
// import http from "../../../libs/http";
// import lodash from "lodash"

// the hook
import { useTranslation } from 'react-i18next';

import ImageMagnifier from 'components/ImageMagnifier'
import cartStore from "../../cart/store";

export default observer(function (props) {
  const { t, i18n } = useTranslation();

  const [picLength, setPicLength] = useState(4)
  const [visible, setVisible] = useState(false)
  const [isBuy, setIsBuy] = useState(false)
  const [picIndex, setPicIndex] = useState(0)
  const [translateX, setTranslateX] = useState(5/192)
  const [num, setNum] = useState(1)
  const step = 119

  const data = Object.assign({}, store.record)
  const query = props.location.search // '?s=1&f=7'
  const arr = query.split('=') // ['?s=', 'f=7']
  let id = arr[1]

  useEffect(() => {
    if (store.recordId === id) return

    store.record = {}
    let key = 'goodsDetail'
    message.loading({content: 'Loading...', key})
    store.recordId = id
    store.fetchRecord(i18n.language).then(() => {
      setPicLength(store.record['mainImageList'] ? store.record['mainImageList']?.length : 0)
    }).finally(() => message.destroy(key))
    store.hotRecords.length === 0 && store.fetchHotRecords();
  }, [id])

  useEffect(() => {
    store.fetchRecord(i18n.language);
  }, [i18n.language])


  // 生成图片列表
  const picListItems = () => {
    let imgList = []
    if (store.record['mainImageList']?.length) {
      store.record['mainImageList'].map((pic, index) =>
      imgList.push((
        <div
          key={index}
          onMouseEnter={() => setPicIndex(index)}
          className={[styles.pic, picIndex === index ? styles.cur : ""].join(" ")}
          style={{backgroundImage: 'url(' + pic + ')'}}
        />
      ))
    )
    }
    return imgList
  }

  // 控制图片移动
  const handleMove = (moveRight = true) => {
    let newVal = translateX + (moveRight ? step : -step)
    newVal <= 5 && newVal >= -(picLength - 4) * step && setTranslateX(newVal/192)
  }

  //加入购物车
  const handleBuy = (isBuy = true) => {
    cartStore.addRecord(store.recordId, isBuy ? 'Sale' : 'Rent', num).then(() => {
      setVisible(true)
      setIsBuy(isBuy)
    })
  }

  const showHtml = (htmlString) => {
    let html = {__html: htmlString};
    return <div dangerouslySetInnerHTML={html}/>;
  }


  return (
    <React.Fragment>

      {!store.record['name'] ? (
        <div style={{textAlign: 'center', margin: '0.2604rem auto'}}><Spin tip="Loading..."/></div>) : (

        <div className={styles.detailContent}>

          <div className={styles.goodsInfo}>
            <div className={styles.picShow}>
              <div className={styles.curPic}>
                <ImageMagnifier className={styles.pic} minImg={data['mainImageList']&&data['mainImageList'][picIndex]}
                                maxImg={data['mainImageList']&&data['mainImageList'][picIndex]}/>
              </div>
              <div className={styles.picBox}>
                <div onClick={handleMove.bind(this, true)} className={styles.leftBtn}>
                  <i className='icon icon-xiala'/>
                </div>
                <div className={styles.picInnerBox}>
                  <div className={styles.picList} style={{
                    transform: 'translateX(' + translateX + 'rem)',
                    width: picLength * step
                  }}>
                    {picListItems()}
                  </div>
                </div>
                <div onClick={handleMove.bind(this, false)} className={styles.rightBtn}>
                  <i className='icon icon-xiala'/>
                </div>
              </div>
            </div>

            <div className={styles.info}>
              <div className={styles.name}>{data['name']}</div>
              <div className={styles.price} hidden={true}>
                <p>泉心价：<span className={styles.val}><span className={styles.lg}>¥ 879.90</span> / 个</span></p>
                <p>市场价：<span className={styles.val}>¥ 979.00 / 个</span></p>
              </div>
              <div className={styles.other}>
                <p style={{fontSize: '0.1042rem',fontWeight:600,color:'#333'}}>{data.brand}</p>
                <p style={{color:"#999"}}>{t('型 号')}：<span className={styles.val}>{data['factoryCode']}</span></p>
                <p style={{color:"#999"}}>{t('规 格')}：<span className={styles.val}>{data['formats']}</span></p>
              </div>
              <div className={styles.store}>
                {t('我需要')}<InputNumber className={styles.num}
                                size="large"
                                min={1}
                                max={data['stock']}
                                value={num}
                                onChange={(num) => setNum(num)}/>{t('台')}
              </div>
              <div className={styles.btnGroup}>
                {
                  !data['leaseAble'] ? null : (
                    <div onClick={() => handleBuy(false)}
                         className={[styles.btn, styles.btnBlue].join(" ")}>{t('我要租')}</div>
                  )
                }
                {
                  !data['saleAble'] ? null : (
                    <div onClick={() => handleBuy(true)}
                         className={[styles.btn, styles.btnBlue, styles.ghost].join(" ")}>{t('我要买')}</div>
                  )
                }

              </div>
            </div>

          </div>

          <div className={styles.moreInfo}>
           

            <div className={styles.richText}>
              <div className={styles.title}>{t('产品详情')}</div>
              <div className="pre">
                {showHtml(data.details)}
              </div>
            </div>

            <div className={styles.related}>
              <div className={styles.title}>{t('设备推荐')}</div>
              <div className={styles.list}>

                <List
                  header=''
                  footer=''
                  dataSource={store.hotRecords}
                  split={false}
                  pagination={false}
                  loading={store.isFetching}
                  renderItem={(item) => (
                    <List.Item>

                      <div className={styles.item} onClick={() => history.replace('/goods/detail?id=' + item.id)}>
                        <div className={styles.name}>{item.name}</div>
                        <div className={styles.desc}>{item.brand} {item['factoryCode']}</div>
                        <div className={styles.img} style={{backgroundImage: `url(${item['thumb']})`}}/>
                      </div>
                    </List.Item>
                  )}
                />
              </div>

            </div>
          </div>

          <Modal
            title={isBuy ? t('购买') : t('租赁')}
            footer={false}
            centered
            getContainer={false}
            visible={visible}
            onOk={() => setVisible(false)}
            onCancel={() => setVisible(false)}
            width={1280}
          >

            <div className={[styles.detailContent, styles.modal].join(" ")}>
              <div className={styles.goodsInfo}>
                <div className={styles.picShow}>
                  <div className={styles.curPic} style={{backgroundImage: 'url(' + data['mainImageList']?.length&&data['mainImageList']&&data['mainImageList'][0] + ')'}}/>
                </div>

                <div className={styles.info}>
                  <div className={styles.name}>{data['name']}</div>
                  <div className={styles.other}>
                    <p style={{fontSize: '0.1146rem'}}>{data.brand}</p>
                    <p>{t('型 号')}：<span className={styles.val}>{data['factoryCode']}</span></p>
                    <p>{t('规 格')}：<span className={styles.val}>{data['formats']}</span></p>
                    <p>{t('数 量')}：<span className={styles.val}>{num}</span></p>
                  </div>
                </div>

                <div className={styles.confirm}>

                  <div className={styles.txt}><i className='icon icon-check'/> {t('已加入求购单，欢迎询价')}</div>


                  <div className={styles.btnGroup}>
                    <Button type='primary' size='large' ghost
                            onClick={() => setVisible(false)}>&lt; {t('返回商品详情')}</Button>
                    <Button type='primary' size='large' onClick={() => history.push('/cart')}>{t('去求购单')}</Button>
                  </div>

                </div>
              </div>

            </div>


          </Modal>

        </div>

      )}

    </React.Fragment>
  )

})

